import { checkIfVideoFeedbackRequestSent } from '../utils/checkIfVideoFeedbackRequestSent';
import { useEffect, useState } from 'react';
import { SessionStore } from '../../constants';

export const useVideoFeedbackRequested = (isFeedbackEnabled: boolean): boolean => {
  const [videoFeedbackRequested, setVideoFeedbackRequested] = useState(false);

  useEffect(() => {
    const checkVideoFeedbackRequested = async (): Promise<void> => {
      setVideoFeedbackRequested(true);
      await checkIfVideoFeedbackRequestSent();
      setVideoFeedbackRequested(false);
    };
    const isVideoFeedbackGenerationRequested = sessionStorage.getItem(SessionStore.isVideoFeedbackGenerationRequested);
    isFeedbackEnabled && isVideoFeedbackGenerationRequested !== 'true' && checkVideoFeedbackRequested();
  }, [isFeedbackEnabled]);

  return videoFeedbackRequested;
};
